import { Component, OnInit } from '@angular/core';
import {ActivatedRoute, Params} from '@angular/router';
import {SessionActivityModel} from '../../../../models/student/session.model';
import {DropdownModel} from '../../../../models/component/dropdown.model';
import {CompetitionModel} from '../../../../models/competition/competition.model';
import {ConsumerCompetitionGoalStats, ConsumerCompetitionStats} from '../../../../models/competition/consumer-competition-stats.model';
import {AdminCompetitionService} from '../../../../services/admin/admin-competition.service';
import {ModalService} from '../../../../shared/modals/modal/modal.service';
import {ErrorModel} from '../../../../models/shared/error.model';

@Component({
  selector: 'app-admin-competitions-dashboard',
  templateUrl: './admin-competitions-dashboard.component.html',
  styleUrls: ['./admin-competitions-dashboard.component.css']
})
export class AdminCompetitionsDashboardComponent implements OnInit {

  Intervals = SessionActivityModel.SessionIntervals;

  dropdownIntervals = [
    new DropdownModel(this.Intervals.Day, 'Day'),
    new DropdownModel(this.Intervals.Week, 'Week'),
    new DropdownModel('total', 'Total')
  ];

  currentInterval = this.dropdownIntervals[2];

  competition: CompetitionModel;
  stats: ConsumerCompetitionStats = null;
  isLoadingStats = false;

  constructor(private route: ActivatedRoute,
              private competitionSv: AdminCompetitionService,
              private modalSv: ModalService) { }

  ngOnInit() {

    this.route.parent.params.subscribe((params: Params) => {

      const competitionId = params.competitionId;
      if (competitionId) {
        this.competitionSv.fetchCompetitionById(competitionId).subscribe((competition) => {
          this.competition = competition;
          if (competition.isConsumer()) {
            this.fetchStats();
          }
        });
      }

    });

  }

  fetchStats() {

    this.isLoadingStats = true;
    this.competitionSv.fetchConsumerStats(this.competition._id).subscribe((stats) => {

      this.stats = stats;
      this.isLoadingStats = false;

    }, (err: ErrorModel) => {

      this.isLoadingStats = false;
      this.modalSv.showTranslatedErrorModal(err);

    });

  }

  formatNumber(value: number): string {
    return Number(value).toLocaleString('en-GB');
  }

  getReachedPercentageLabel(goal: ConsumerCompetitionGoalStats): string {
    return this.stats.getReachedPercentage(goal).toFixed(1) + '%';
  }

  getReachedPercentage(goal: ConsumerCompetitionGoalStats): number {
    return this.stats.getReachedPercentage(goal);
  }

  /**
   * The stats list the goals in the competition's goal order, the name comes from the competition.
   */
  getGoalName(index: number): string {

    const name = this.competition.getGoalName(index, 'en-GB');
    if (name) {
      return name;
    }

    return 'Goal ' + (index + 1);

  }

  getUpdatedAtLabel(): string {

    if (!this.stats || !this.stats.updatedAt) {
      return '';
    }

    return this.stats.updatedAt.toLocaleTimeString('en-GB');

  }

}
